const createPackageActionTypes = {
    RETRIEVED_PACKAGE_MANIFEST: "RETRIEVED_PACKAGE_MANIFEST",
    CREATED_PACKAGE_MANIFEST: "CREATED_PACKAGE_MANIFEST",
    UPDATED_PACKAGE_MANIFEST: "UPDATED_PACKAGE_MANIFEST",
    UPDATED_PACKAGE_PAYLOAD: "UPDATED_PACKAGE_PAYLOAD",
    RETRIEVED_GENERATED_MANIFEST: "RETRIEVED_GENERATED_MANIFEST",
    REFRESH_PACKAGE_FILES: "REFRESH_PACKAGE_FILES",
    CREATED_PACKAGE: "CREATED_PACKAGE",
    GO_TO_STEP: "GO_TO_STEP"
};
export default createPackageActionTypes;